import { useEffect, useRef, useState } from 'react';

// Try Socket.IO first, fall back to native WebSocket, then local simulation
export function useWebSocket() {
  const wsRef   = useRef(null);
  const ioRef   = useRef(null);
  const [alerts, setAlerts] = useState([
    { id:'A1', time:'14:23:07Z', msg:'AARO radar anomaly — Pacific Fleet Zone 7',    level:'AMBER' },
    { id:'A2', time:'14:19:44Z', msg:'EM signature spike — Nevada Test Range',       level:'RED'   },
    { id:'A3', time:'14:11:02Z', msg:'Unidentified contact — ADIZ perimeter',        level:'RED'   },
    { id:'A4', time:'13:58:31Z', msg:'Mass witness event — São Paulo metro',         level:'GREEN' },
    { id:'A5', time:'13:44:18Z', msg:'Transmedium contact — USS Omaha AOR',          level:'RED'   },
  ]);
  const [alertCount, setAlertCount] = useState(5);

  useEffect(() => {
    const MSGS = [
      { msg:'AARO: New EM signature — Grid 47-N, North Atlantic',          level:'AMBER' },
      { msg:'DoD: Geomagnetic spike — Northern Europe sector',             level:'GREEN' },
      { msg:'NORAD: Radar contact lost — Gulf of Mexico',                  level:'RED'   },
      { msg:'ONI: Thermal anomaly — Western Pacific Basin',                level:'AMBER' },
      { msg:'CENTCOM: Formation detected — 3 objects, 80,000ft',           level:'RED'   },
      { msg:'NRO: Nuclear proximity alert — Eastern Europe',               level:'RED'   },
      { msg:'NORTHCOM: Tracking anomaly — Arctic sector',                  level:'AMBER' },
      { msg:'Navy: Transmedium contact — San Diego offshore',              level:'RED'   },
      { msg:'JASDF: Contact — Sea of Japan, 90° turn confirmed',           level:'RED'   },
      { msg:'AARO: 2026 Annual Report — 47 new unexplained cases',         level:'AMBER' },
      { msg:'ISS crew visual — structured object, low earth orbit',        level:'AMBER' },
      { msg:'USAF: Pilot report — no thermal signature detected',          level:'RED'   },
      { msg:'FBI: Declassified memo released — 1952 DC overflights',       level:'GREEN' },
      { msg:'NSA: SIGINT anomaly — encrypted signal, unknown origin',      level:'RED'   },
      { msg:'DIA: Pattern convergence — 3 hotspots simultaneously active', level:'RED'   },
    ];
    let idx = 0;

    const addAlert = (msg, level) => {
      const now = new Date();
      const ts  = `${String(now.getUTCHours()).padStart(2,'0')}:${String(now.getUTCMinutes()).padStart(2,'0')}:${String(now.getUTCSeconds()).padStart(2,'0')}Z`;
      setAlerts(prev => [{ id:`${Date.now()}`, time:ts, msg, level }, ...prev.slice(0,14)]);
      setAlertCount(n => n+1);
    };

    // Local simulation — runs always as fallback
    const iv = setInterval(() => {
      const m = MSGS[idx % MSGS.length]; idx++;
      addAlert(m.msg, m.level);
    }, 8000);

    // Try Socket.IO
    const WS_URL = process.env.REACT_APP_WS_URL || process.env.REACT_APP_API_URL;
    if (WS_URL) {
      try {
        // Dynamic import Socket.IO to avoid build issues if not available
        import('socket.io-client').then(({ io }) => {
          const socket = io(WS_URL, {
            transports:  ['websocket', 'polling'],
            timeout:     5000,
            reconnectionAttempts: 3,
          });
          ioRef.current = socket;

          socket.on('live_alert', (d) => {
            addAlert(d.msg, d.level);
          });

          socket.on('intelligence_update', (d) => {
            if(d.newSightings > 0) addAlert(`DEEPSPACE: ${d.newSightings} new anomaly detected`, 'RED');
          });

          socket.on('prediction_update', (d) => {
            if(d.globalThreatLevel === 'RED') addAlert('DEEPSPACE: Global threat elevated to RED', 'RED');
          });

        }).catch(() => {
          // Socket.IO not available — fallback to native WebSocket
          tryNativeWS(WS_URL, addAlert);
        });
      } catch(_) {
        tryNativeWS(WS_URL, addAlert);
      }
    }

    return () => {
      clearInterval(iv);
      if(ioRef.current)  { ioRef.current.disconnect(); ioRef.current = null; }
      if(wsRef.current)  { wsRef.current.close(); wsRef.current = null; }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { alerts, alertCount };
}

function tryNativeWS(url, addAlert) {
  try {
    const wsUrl = url.replace('https://', 'wss://').replace('http://', 'ws://');
    const ws    = new WebSocket(wsUrl);
    ws.onmessage = (e) => {
      try {
        const d = JSON.parse(e.data);
        if(d.type === 'live_alert') addAlert(d.msg, d.level);
      } catch(_) {}
    };
  } catch(_) {}
}
